import React from 'react';
import { Mail, Phone, MapPin, MessageCircle, ArrowRight } from 'lucide-react';

const Contact = () => {
  const whatsappNumber = '917827327243';
  const whatsappMessage = 'Hi! I have a question about Delhi Guided Tours.';

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)', textAlign: 'center' }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>Get in Touch</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Have questions about our tours? Want to book a private experience? We're here to help.
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px', marginBottom: '80px' }}>
            <div style={{ textAlign: 'center', padding: '32px', border: '1px solid var(--border-light)', background: 'var(--bg-primary)' }}>
              <div style={{ width: '60px', height: '60px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                <MessageCircle size={28} color="#25D366" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>WhatsApp</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Quick responses, instant booking
              </p>
              <a
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                Chat with us
                <ArrowRight size={16} />
              </a>
            </div>

            <div style={{ textAlign: 'center', padding: '32px', border: '1px solid var(--border-light)', background: 'var(--bg-primary)' }}>
              <div style={{ width: '60px', height: '60px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                <Phone size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>Phone</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Speak directly with our team
              </p>
              <a href="tel:+917827327243" className="btn-secondary">
                +91 7827 327 243
              </a>
            </div>

            <div style={{ textAlign: 'center', padding: '32px', border: '1px solid var(--border-light)', background: 'var(--bg-primary)' }}>
              <div style={{ width: '60px', height: '60px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                <Mail size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>Email</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Detailed inquiries and bookings
              </p>
              <a href="mailto:joshuaguides247@gmail.com" className="btn-secondary">
                joshuaguides247@gmail.com
              </a>
            </div>
          </div>

          {/* Removed Contact Form - WhatsApp is primary contact method */}
        </div>
      </section>

      {/* Location */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
            <MapPin size={32} color="var(--text-primary)" style={{ margin: '0 auto 20px' }} />
            <h2 className="heading-2" style={{ marginBottom: '12px' }}>Our Base</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
              New Delhi, India
            </p>
            <p className="body-regular" style={{ color: 'var(--text-light)' }}>
              Operating city-wide tours across Delhi NCR
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;